module.exports = __webpack_public_path__ + "static/bg-footer-ce11c550177cadf0300fca9194753d0d.png";